// extracted by mini-css-extract-plugin
export default {"container":"TextTItle_container__goZJQ","title":"TextTItle_title__CoHsf","animated":"TextTItle_animated__1oXIW","dividerline":"TextTItle_dividerline__8suqf"};